module.exports = __webpack_public_path__ + "img/slide-3-en.40dd66d7.png";